export function useGetSomeMoreChartData(data) {

    const config = {

        type: 'line',
        data: {
            labels: data.map(each => each.label),
            datasets: [{
                label: 'Other Data',
                data: data.map(each => each.value),
                borderWidth: 1,
                backgroundColor: [
                    'rgba(157,63,63,0.5)',
                    'rgb(37,91,52)',
                    'rgba(138,121,121,0.5)',
                    'rgb(121,30,169)',
                    'rgb(41,114,134)',
                    'rgb(47,102,8)',
                ],
            }],

        },
        options: {
            plugins: {
                legend: {
                    display: true,
                    position: 'top',
                    labels: {
                        boxWidth: 13,
                    }
                },

            },
            responsive: true,
            hoverOffset: 15,
            scales: {},
            layout: {
                padding: 20,
                font: {
                    family: 'roboto'
                }
            }
        }

    }

    return config;

}
